<template>
  <AuthLayout
    pitch-title="Encontre quem sua rede já validou."
    pitch-sub="Publique vagas gratuitamente e contrate profissionais de TI indicados por quem confia neles."
  >
    <template #aside-extra>
      <div class="login-metrics">
        <div class="login-metrics__item">
          <span class="login-metrics__value">+50.000</span>
          <span class="login-metrics__label">profissionais registrados</span>
        </div>
        <div class="login-metrics__item">
          <span class="login-metrics__value">+1.000</span>
          <span class="login-metrics__label">contratações realizadas</span>
        </div>
      </div>
    </template>

    <LoginForm :isModal="false" :isCompany="true" />
  </AuthLayout>
</template>

<script>
import AuthLayout from '../components/ui/AuthLayout.vue';
import LoginForm from '../modules/person/components/Forms/LoginForm.vue';

export default {
  name: 'LoginCompany',
  components: {
    AuthLayout,
    LoginForm,
  },
};
</script>

<style scoped>
.login-metrics {
  display: flex;
  flex-direction: column;
  gap: var(--gap-md);
}

.login-metrics__item {
  display: flex;
  align-items: center;
  gap: var(--gap-md);
  padding: 16px 20px;
  background: var(--cyan-glow);
  border: 1px solid var(--navy-border);
  border-radius: var(--r-md);
}

.login-metrics__value {
  font-family: var(--font-brand);
  font-size: 18px;
  font-weight: 800;
  color: var(--cyan);
}

.login-metrics__label {
  font-family: var(--font-brand);
  font-size: 13px;
  color: var(--muted);
}
</style>
